import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {withStyles, createStyleSheet} from 'material-ui/styles';
import Table, {TableBody, TableCell, TableHead, TableRow} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import {abbreviations} from './constants'

const styleSheet = createStyleSheet('Table', theme => ({
    paper: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    cell: {
        whiteSpace: 'normal',
    }
}));

class Abbreviations extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    render() {
        const classes = this.props.classes;
        return (
            <Paper className={classes.paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Abreviatura</TableCell>
                            <TableCell>Significado</TableCell>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {abbreviations.map(n => {
                            let key = Object.keys(n)[0];
                            return (
                                <TableRow key={key}>
                                    <TableCell>{key}</TableCell>
                                    <TableCell className={classes.cell}>{n[key]}</TableCell>
                                </TableRow>)
                        })}

                    </TableBody>
                </Table>
            </Paper>
        )
    }
}


Abbreviations.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Abbreviations);



// WEBPACK FOOTER //
// ./src/abbreviations.jsx